import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Wrapper = styled.div`
    box-sizing: border-box;
    width: 100%;
    min-height: 655px;
    color: white;
    padding-block: 5vw 1vw;
    background: ${({ bgColor }) => bgColor};
    position: relative;
    display: flex;

    @media (max-width: 1100px) {
        min-height: unset;
    }

    @media (max-width: 900px) {
        height: auto;
    }
    @media (max-width: 600px) {
        padding-block: 35px;
    }
`;

export const Inner = styled.div`
    width: 93%;
    margin: 0px auto;
    max-width: 1600px;
    min-width: 1200px;
    direction: ltr;
    position: relative;
    justify-content: space-between;
    display: flex;
    @media (max-width: 1200px) {
        min-width: 100%;
        max-width: 100%;
        padding-inline: 15px;
        box-sizing: border-box;
    }
    @media (max-width: 900px) {
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px;
        /* flex-direction: column; */
    }
`;

export const Content = styled.div`
    position: relative;
    width: 38%;
    height: fit-content;
    min-height: 100%;
    display: flex;
    align-items: center;

    @media (max-width: 1100px) {
        width: 450px;
        margin: 0px auto;
    }
    @media (max-width: 900px) {
        min-width: 80%;
        min-height: fit-content;
        justify-content: center;
        & h2 {
            text-align: center;
        }
    }
`;
export const Text = styled(motion.div)`
    font-size: 34px;
    color: white;
    max-width: 550px;
    display: flex;
    gap: 10px;
    flex-direction: column;
    white-space: pre-wrap;
    & h2 {
        margin: 0;
        font-size: 48px;
        color: #5fd65d;
    }
    @media (max-width: 1200px) {
        font-size: 28px;

        & h2 {
            font-size: 40px;
        }
    }
`;

export const ImgContainer = styled.div`
    width: 48%;
    position: relative;
    @media (max-width: 900px) {
        min-width: 320px;
    }
`;

export const Circle = styled(motion.img)`
    width: 100%;
    position: absolute;
    /* top: 50%; */
    margin-block: auto;
    transform: translateY(-50%);
    right: 0;
    @media (max-width: 900px) {
        min-width: 125%;
        margin-right: -10.5%;
    }
`;

export const DeviceImg = styled(motion.img)`
    position: relative;
    width: 65%;
    top: 0;
    margin-inline-start: auto;
    display: block;
    margin-inline-end: 8%;
    min-width: 465px;

    @media (max-width: 1100px) {
        min-width: 320px;
    }
    @media (max-width: 900px) {
        min-width: 90%;
    }
`;
